$(document).ready(function() {

  var $form = $('#AddToCartForm');

  // variant picker init
  var options = {
    $container: $form,
    enableHistoryState: true,
    singleOptionSelector: $form.find('.single-option-selector'),
    originalSelectorId: $form.find('[name="id"]'),
    product: window.product
  };

  var variants = new slate.Variants(options);

});
